<bzg-modal-header>
  <div class="bmc-expiration-session__header">
      <span>{{ 'SESSION.TITLE_MODAL' | translate }}</span>
      <bzg-button-icon class="bmc-expiration-session__icon-exit" *ngIf="data.expired" icon="icon-close" (click)="close()"></bzg-button-icon>
  </div>
</bzg-modal-header>
<bzg-modal-content class="bmc-expiration-session__content">
  <div *ngIf="!data.expired" class="bmc-expiration-session__body">
    <bzg-icon [nameIcon]="'icon-warning'" [size]="24" [color]="'warning'"></bzg-icon>
    <div class="bmc-expiration-session__body__description">
      <p>{{ 'SESSION.MESSAGE_SESSION_CLOSE_EXPIRE_TEXT' | translate }}</p>
      <p>{{ 'SESSION.MESSAGE_SESSION_CLOSE_EXPIRE_ACTION' | translate }}</p>
    </div>
  </div>
  <div *ngIf="data.expired" class="bmc-expiration-session__body">
    <bzg-icon [nameIcon]="'icn-input-error'" [size]="24" [color]="'error'"></bzg-icon>
    <div class="bmc-expiration-session__body__description">
      <p>{{ 'SESSION.MESSAGE_SESSION_EXPIRED' | translate }}</p>
    </div>
  </div>
</bzg-modal-content>
<bzg-modal-footer *ngIf="!data.expired" class="bmc-expiration-session__footer">
  <bzg-button-primary (click)="confirm()">{{ 'SESSION.CONFIRM' | translate }}</bzg-button-primary>
</bzg-modal-footer>
